<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label">{{ label }}:</label>

    <div class="flex flex-wrap">
      <div v-for="(label, value) in options" :key="value" class="mr-4">
        <label :for="id + value" class="wrapper flex items-center">
          <input
            :id="id + value"
            v-model="selectedValue"
            :value="value"
            :checked="isChecked(value)"
            class="checkbox mr-2" type="checkbox" @change="$emit('update:modelValue', selectedValue)"
          />
          {{ label }}
        </label>
      </div>
    </div>

    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `select-input-${uuid()}`
      },
    },

    modelValue: {
      type: Array,
      default: () => [],
    },

    error: {
      type: String,
    },

    label: {
      type: String,
    },

    value: {
      type: String,
    },

    options: {
      type: Object,
    },
  },
  emits: ['update:modelValue'],

  data() {
    return {
      selectedValue: this.$props.modelValue,
    }
  },

  methods: {
    isChecked(option) {
      return this.modelValue.indexOf(option.value) >= 0
    },
  },
}
</script>
